// CoryChat inline styles — pulled out so the bubble + panel share the
// same source. Keep these here rather than Tailwind because the
// gradients + shadows are pixel-tuned and Tailwind's arbitrary value
// syntax would force a class explosion.

export const bubbleStyle = {
  background: 'linear-gradient(145deg, #0A84FF 0%, #0055CC 100%)',
  backdropFilter: 'blur(40px) saturate(160%)',
  WebkitBackdropFilter: 'blur(40px) saturate(160%)',
  boxShadow:
    '0 4px 20px rgba(0,102,204,0.4), 0 8px 32px -4px rgba(0,0,0,0.18), inset 0 1px 0 rgba(255,255,255,0.4), inset 0 -1px 0 rgba(0,0,0,0.1)',
};

export const bubbleHoverStyle = {
  boxShadow:
    '0 6px 28px rgba(0,102,204,0.5), 0 14px 44px -4px rgba(0,0,0,0.22), inset 0 1px 0 rgba(255,255,255,0.5), inset 0 -1px 0 rgba(0,0,0,0.12)',
};

export const panelStyle = {
  background: 'rgba(255,255,255,0.82)',
  backdropFilter: 'blur(40px) saturate(160%)',
  WebkitBackdropFilter: 'blur(40px) saturate(160%)',
  boxShadow: '0 32px 80px -12px rgba(0,0,0,0.25), inset 0 1px 0 rgba(255,255,255,0.6), 0 0 0 1px rgba(0,0,0,0.06)',
};

export const avatarGradient = {
  background:
    'radial-gradient(ellipse at 30% 20%, rgba(99,102,241,0.3) 0%, rgba(15,23,42,0.85) 70%)',
};

export const messageAvatarGradient = {
  background:
    'radial-gradient(ellipse at 30% 20%, rgba(99,102,241,0.25) 0%, rgba(30,41,59,0.85) 70%)',
};

export const emptyStateGradient = {
  background:
    'radial-gradient(ellipse at 30% 20%, rgba(99,102,241,0.2) 0%, rgba(241,245,249,1) 70%)',
};
